/**
 * Kako se otvaraju generisani Excel fajlovi.
 *
 * "excel"   — fajl se preda desktop Excelu preko Office URI šeme (ms-excel:),
 *             pa se otvori odmah, bez spašavanja u Preuzimanja. Fajl ide
 *             direktno iz baze u Excel, ne prolazi ni kroz kakav tuđi servis.
 * "preuzmi" — staro ponašanje: snimi pa otvori ručno.
 *
 * Podrazumijevano je "preuzmi": Excel na nekim računarima ne otvara dugu
 * potpisanu adresu (upozorenje o virusima, pa "file could not be accessed").
 * Izbor se pamti po pregledniku, jer je stvar navike pojedinca.
 */
export type Nacin = 'excel' | 'preuzmi';

const KLJUC = 'triglav.nacin-otvaranja.v2';

export function ucitajNacin(): Nacin {
  try {
    return localStorage.getItem(KLJUC) === 'excel' ? 'excel' : 'preuzmi';
  } catch {
    return 'preuzmi';
  }
}

export function spremiNacin(n: Nacin): void {
  try { localStorage.setItem(KLJUC, n); } catch { }
}

/**
 * Otvori fajl s potpisanog URL-a.
 *
 * Kod "excel" se ne može provjeriti je li se Excel stvarno pokrenuo — ako
 * šema nije registrovana, preglednik je tiho ignoriše. Zato pozivatelj uz
 * dugme drži i vidljivu opciju preuzimanja.
 */
export function otvoriFajl(url: string, nacin: Nacin, imeZaSnimanje?: string): void {
  if (nacin === 'excel') {
    // BBS mjesečna lista je Word dokument — otvara je Word, ne Excel.
    const program = imeZaSnimanje?.toLowerCase().endsWith('.docx') ? 'ms-word' : 'ms-excel';
    window.location.href = `${program}:ofv|u|${url}`;
    return;
  }
  const klik = (href: string, novi: boolean) => {
    const a = document.createElement('a');
    a.href = href;
    if (novi) a.target = '_blank';
    if (imeZaSnimanje) a.download = imeZaSnimanje;
    a.click();
  };
  if (!imeZaSnimanje) { klik(url, true); return; }
  // `download` se za adresu s drugog domena (Supabase) ignoriše, pa bi se fajl
  // snimio pod dugim imenom iz potpisane adrese, a Excel takav ne otvori
  // ("rename the file to use a shorter name"). Zato se prvo povuče u
  // preglednik i snimi pod zadanim kratkim imenom.
  fetch(url)
    .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.blob(); })
    .then(blob => {
      const lokalni = URL.createObjectURL(blob);
      klik(lokalni, false);
      setTimeout(() => URL.revokeObjectURL(lokalni), 60000);
    })
    .catch(() => klik(url, true));
}
